@if (address) {
  <form [formGroup]="addressFormGroup" fxLayout="column">
    @if (!isHidden.Country) {
      <mat-form-field
        id="Country"
        appearance="outline"
        floatLabel="always"
        fxFlex="100%"
      >
        <mat-label>Country</mat-label>
        <mat-select
          [required-aria]="isRequired.Country"
          [formControl]="addressFormGroup.controls.country"
          (selectionChange)="address.countryChanged()"
        >
          <mat-option value="">Select</mat-option>
          @for (country of address.countries; track country) {
            <mat-option [value]="country.code">
              {{ country.name }}
            </mat-option>
          }
        </mat-select>
        @if (addressFormGroup.controls.country.hasError('notEmpty')) {
          <mat-error>
            {{ addressFormGroup.controls.country.getError('notEmpty') }}
          </mat-error>
        }
      </mat-form-field>
    }
    @if (!isHidden.Address1) {
      <mat-form-field
        id="Address1"
        appearance="outline"
        floatLabel="always"
        fxFlex="100%"
      >
        <mat-label>Street Address 1</mat-label>
        <input
          matInput
          forbidAngleBrackets
          type="text"
          [formControl]="addressFormGroup.controls.streetAddress1"
          [required-aria]="isRequired.Address1"
          autocomplete="address-line1"
        />
        @if (addressFormGroup.controls.streetAddress1.hasError('notEmpty')) {
          <mat-error>
            {{ addressFormGroup.controls.streetAddress1.getError('notEmpty') }}
          </mat-error>
        }
      </mat-form-field>
    }
    @if (!isHidden.Address1) {
      <mat-form-field
        id="Address2"
        appearance="outline"
        floatLabel="always"
        fxFlex="100%"
      >
        <mat-label>Street Address 2</mat-label>
        <input
          matInput
          forbidAngleBrackets
          type="text"
          [formControl]="addressFormGroup.controls.streetAddress2"
          autocomplete="address-line2"
        />
      </mat-form-field>
    }
    @if (!isHidden.City) {
      <mat-form-field
        id="City"
        appearance="outline"
        floatLabel="always"
        fxFlex="100%"
      >
        <mat-label>City</mat-label>
        <input
          matInput
          forbidAngleBrackets
          type="text"
          [formControl]="addressFormGroup.controls.city"
          [required-aria]="isRequired.City"
          autocomplete="address-level2"
        />
        @if (addressFormGroup.controls.city.hasError('notEmpty')) {
          <mat-error>
            {{ addressFormGroup.controls.city.getError('notEmpty') }}
          </mat-error>
        }
      </mat-form-field>
    }
    @if (!isHidden.StateOrProvince || !isHidden.PostalCode) {
      <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between">
        @if (!address.regionVisible && !isHidden.StateOrProvince) {
          <mat-form-field
            id="StateOrProvince"
            floatLabel="always"
            appearance="outline"
            [fxFlex]="!isHidden.PostalCode ? '60%' : '100%'"
            fxFlex.lt-sm="100%"
          >
            <mat-label>{{ address.getLabel() }}</mat-label>
            <mat-select
              [required-aria]="isRequired.StateOrProvince"
              [formControl]="addressFormGroup.controls.stateOrRegion"
            >
              <mat-option value="">Select</mat-option>
              @for (state of address.getStatesOrProvinces(); track state) {
                <mat-option [value]="state.code">
                  {{ state.name }}
                </mat-option>
              }
            </mat-select>
            @if (addressFormGroup.controls.stateOrRegion.hasError('notEmpty')) {
              <mat-error>
                {{
                  addressFormGroup.controls.stateOrRegion.getError('notEmpty')
                }}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (address.regionVisible && !isHidden.StateOrProvince) {
          <mat-form-field
            id="StateOrProvince"
            appearance="outline"
            floatLabel="always"
            [fxFlex]="!isHidden.PostalCode ? '60%' : '100%'"
            fxFlex.lt-sm="100%"
          >
            <mat-label>State / Region / Province</mat-label>
            <input
              matInput
              forbidAngleBrackets
              type="text"
              [formControl]="addressFormGroup.controls.stateOrRegion"
              [required-aria]="isRequired.StateOrProvince"
            />
            @if (addressFormGroup.controls.stateOrRegion.hasError('notEmpty')) {
              <mat-error>
                {{
                  addressFormGroup.controls.stateOrRegion.getError('notEmpty')
                }}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (!isHidden.PostalCode) {
          <mat-form-field
            id="PostalCode"
            appearance="outline"
            floatLabel="always"
            [fxFlex]="!isHidden.StateOrProvince ? '35%' : '100%'"
            fxFlex.lt-sm="100%"
          >
            <mat-label>Postal Code</mat-label>
            <input
              matInput
              forbidAngleBrackets
              type="text"
              [formControl]="addressFormGroup.controls.postalCode"
              [required-aria]="isRequired.PostalCode"
              autocomplete="postal-code"
            />
            @if (addressFormGroup.controls.postalCode.hasError('notEmpty')) {
              <mat-error>
                {{ addressFormGroup.controls.postalCode.getError('notEmpty') }}
              </mat-error>
            }
          </mat-form-field>
        }
      </div>
    }
    @if (false) {
      <mat-checkbox
        id="AddressIsShared"
        [formControl]="addressFormGroup.controls.isShared"
        color="primary"
        >{{ address.isSharedLabel }}</mat-checkbox
      >
    }
  </form>
}
